<h3 mat-dialog-title class="text-left">{{ data.attachment.filename }}</h3>
<img (click)="close()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg" alt="close">

<mat-dialog-content>
    <div *ngIf="fileLoading"
         class="animated fadeIn position-relative d-flex justify-content-center align-items-center"
         [style.height]="containerHeight">
        <div class="loader position-absolute"></div>
    </div>

    <ng-container *ngIf="!fileLoading">
        <pdf-viewer
            *ngIf="data.attachment.isPdf"
            [autoresize]="true"
            [external-link-target]="'blank'"
            [fit-to-page]="true"
            [original-size]="false"
            [render-text]="true"
            [show-all]="true"
            [src]="pdfSrc"
            class="fadeIn animated"
            [style.width]="'100%'"
            [style.height]="containerHeight">
        </pdf-viewer>

        <div *ngIf="data.attachment.isImage" class="overflow-auto text-center" [style.height]="containerHeight">
            <img [src]="imgSrc" class="img-fluid" alt="Attachment preview">
        </div>

        <div *ngIf="!data.attachment.isPreviewable" class="unsupported text-center py-5">
            <!-- attachment.icon is the full FontAwesome class string; matIcon.icon is a slug that
                 will NOT render inside <mat-icon>. Use the FA <i>, matching the manage dialog. -->
            <i class="{{ data.attachment.icon }} fa-3x text-muted mb-3"></i>
            <p class="mb-1"><strong>{{ data.attachment.filename }}</strong></p>
            <p class="text-muted mb-1">{{ data.attachment.filesize }}</p>
            <p class="text-muted">Preview isn't available for this file type. Use Download to save it.</p>
        </div>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
    <app-button (onClick)="close()">Close</app-button>
    <app-button
        (onClick)="download()"
        [buttonClasses]="['mr-0']"
        [isDisabled]="isDownloading"
        type="primary">
        Download
    </app-button>
</mat-dialog-actions>
